import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { gql } from "@apollo/client";
import VariantOption from "./VariantOption";
import { useUpdateProductSelection } from "../cache/ChooseSubscriptionScreenFunctions";
gql `
  fragment ChooseProduct on Product {
    ...ChooseSubscriptionScreenProduct
  }
`;
gql `
  fragment ChooseProductSelection on ProductSelection {
    product {
      ...ChooseSubscriptionScreenProduct
    }
    variant {
      ...ChooseSubscriptionScreenVariant
    }
  }
`;
const ChooseProductSelection = ({ fulfillmentId, product, productSelection, }) => {
    var _a;
    const updateProductSelection = useUpdateProductSelection(product.id, fulfillmentId);
    const isDisabled = (product.variants.length < 2);
    const defaultVariant = product.variants.length < 2 ? product.variants[0] : null;
    const hasValidProductSelectionVariant = product.variants.some(v => { var _a; return v.id == ((_a = productSelection === null || productSelection === void 0 ? void 0 : productSelection.variant) === null || _a === void 0 ? void 0 : _a.id); });
    const selectReference = useRef(null);
    useEffect(() => {
        var _a;
        if (selectReference.current && !hasValidProductSelectionVariant && !!defaultVariant) {
            // @ts-ignore
            (_a = selectReference.current._valueTracker) === null || _a === void 0 ? void 0 : _a.setValue("");
            selectReference.current.dispatchEvent(new Event("change", { bubbles: true }));
        }
    }, []);
    return (_jsxs("div", { className: "my-4", children: [_jsx("h4", { className: "my-4 block pt-4", children: product.name }), product.id == "6dd6a34f-3d12-4f6a-b047-b29484b6b4ab" ? _jsx("div", { className: "mb-4 block text-wfGray-600 text-sm", children: "Select from any of our 25 book clubs." }) : "", _jsxs("select", { ref: selectReference, value: hasValidProductSelectionVariant ? (_a = productSelection === null || productSelection === void 0 ? void 0 : productSelection.variant) === null || _a === void 0 ? void 0 : _a.id : defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.id, onChange: updateProductSelection, className: "p-2 w-full border border-wfGray-300 focus:border-salmon-600 focus:border-2 text-lg", disabled: isDisabled, style: isDisabled ? {
                    backgroundColor: "#eee",
                    opacity: .6,
                } : {}, children: [_jsx("option", { value: "", children: "Choose option" }, "0"), product.variants.map((variant) => {
                        return _jsx(VariantOption, Object.assign({}, variant), variant === null || variant === void 0 ? void 0 : variant.id);
                    })] })] }));
};
export default ChooseProductSelection;
